import React from 'react';

import TableWidgetResourceLibrary from '../../../../../cyder/table/TableWidgetResourceLibrary';

const MemberResourcesPartnerEvents = ({ partnerEvents }) => <TableWidgetResourceLibrary items={partnerEvents} />;

export default MemberResourcesPartnerEvents;
